import { atom } from 'jotai';
import { atomWithHash } from 'jotai-location';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import dayjs from 'dayjs';
import axiosApiInstance from '../../../api/axiosClient';

export interface TikTokAccount {
  label: string;
  value: string;
}

// Form state atoms with URL hash persistence
export const selectedAccountAtom = atomWithHash<string | undefined>('account', undefined);
export const selectedStartDateAtom = atomWithHash<string>(
  'startMonth',
  dayjs().subtract(1, 'month').format('YYYY-MM')
);
export const selectedEndDateAtom = atomWithHash<string>(
  'endMonth',
  dayjs().subtract(1, 'month').format('YYYY-MM')
);

// Data fetching atoms with suspense
export const accountsAtom = atomWithSuspenseQuery<TikTokAccount[]>(() => ({
  queryKey: ['tiktok-accounts'],
  queryFn: async () => {
    const response = await axiosApiInstance.get('/api/tiktok-reports/accounts');
    return response.data;
  }
}));

// Generated report result
export interface SingleReportResult {
  presentationUrl: string;
  spreadsheetUrl: string;
  presentationId: string;
  spreadsheetId: string;
  month: number;
  year: number;
}

export interface ReportResult {
  reports: SingleReportResult[];
}

// UI state atoms
export const reportResultAtom = atom<ReportResult>({reports: []});
export const isGeneratingAtom = atom<boolean>(false);